export const formDataLayerPush = (event, value = 50, location = 'UK') => {
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    conversionValue: value,
    location: location,
    event: event,
  });
};
